module.exports = __webpack_public_path__ + "media/images/banner_example_mobile-41f151ec9b28594f9e5286dcf9d391d7.png";